import { render } from "./DgpoBpmCard.vue?vue&type=template&id=a7f704e2"
import script from "./DgpoBpmCard.vue?vue&type=script&lang=js"
export * from "./DgpoBpmCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__